export default __webpack_public_path__ + "static/media/food.a3efe875.png";